export default __webpack_public_path__ + "static/media/empty.d9468855.svg";